<template>
    <div class="clearfix birth-number-field">
        <input class="form-control" type="text" v-model="firstPart" maxlength="6" :disabled="disabled">
        <div class="form-control-divider">/</div>
        <input class="form-control" type="text" v-model="secondPart" maxlength="4" :disabled="disabled">
    </div>
</template>
<script>
    import {abstractField} from 'vue-form-generator'

    export default {
        mixins: [abstractField],
        watch: {
            value(newValue, prevValue) {
                if (prevValue === undefined || prevValue !== this.getFullValue()) {
                    this.initInput();
                }
            },
            firstPart() {
                this.saveValue();
            },
            secondPart() {
                this.saveValue();
            }
        },
        created() {
            this.initInput();
        },
        methods: {
            initInput() {
                if (this.value !== undefined) {
                    if (this.value.includes('/')) {
                        const valueArray = this.value.split('/');
                        this.firstPart = valueArray[0];
                        this.secondPart = valueArray[1];
                    } else {
                        this.firstPart = this.value;
                    }
                }
            },
            saveValue() {
                this.value = this.getFullValue();
            },
            getFullValue() {
                return this.firstPart + '/' + this.secondPart;
            }
        },
        data() {
            return {
                firstPart: '',
                secondPart: '',
            }
        }
    };
</script>
<style lang="scss">
    .birth-number-field {
        width: 100%;

        .form-control {
            float: left;

            &:first-child {
                width: 50%;
            }
            &:last-child {
                width: 40%;
            }
        }

        .form-control-divider {
            float: left;
            width: 10%;
            height: calc(1.5em + 0.75rem + 2px);
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            padding: 0.375rem 0;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/form/birthNumber.vue